<template>
  <v-carousel
    cycle
    height="400"
    hide-delimiter-background
    show-arrows-on-hover
  >
    <v-carousel-item
      v-for="(slide, i) in slides"
      :key="i"
      :src=slide.url
    >
      <v-sheet
        :color="colors[i]"
        height="100%"
      >
        <v-row
          class="fill-height"
          align="center"
          justify="center"
        >
          <div class="text-h2">
            {{ slide }} Slide
          </div>
        </v-row>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>


<script>
  export default {
    data () {
      return {
        colors: [
          {url:require('../assets/Banner9.jpg')},
          {url:require('../assets/Banner1.jpg')},
          {url:require('../assets/Banner7.jpg')},
          {url:require('../assets/Banner8.jpg')},
          {url:require('../assets/Banner2.jpg')},
        ],
        slides: [
           {url:require('../assets/Banner9.jpg')},
           {url:require('../assets/Banner1.jpg')},
           {url:require('../assets/Banner7.jpg')},
           {url:require('../assets/Banner8.jpg')},
           {url:require('../assets/Banner2.jpg')},
        ],
      }
    },
  }
</script>





<style>
 

</style>